/** Identificadores de módulo del backend (`user_permisos[].modulo.identificador`). */
export const MOD_USER = 'mod_user';
export const MOD_ROL = 'mod_rol';
export const MOD_CUENTA = 'mod_cuenta';
export const MOD_FACTURA = 'mod_factura';
export const MOD_CUOTA_PENDIENTE = 'mod_cuota_pendiente';
export const MOD_CONTRATO = 'mod_contrato';
export const MOD_CONTRATO_PRODUCTOS = 'mod_contratos_producto';
export const MOD_ARTICULO = 'mod_articulo';
export const MOD_FAMILIA = 'mod_familia';
export const MOD_EXPEDIENTE = 'mod_expediente';
export const MOD_SUPPORT = 'mod_support';

/** Acceso a pantallas/menú Contratos: basta con lectura/escritura en cualquiera. */
export const MODS_CONTRATOS_ACCESS = [MOD_CONTRATO, MOD_CONTRATO_PRODUCTOS] as const;

/** Acceso a pantallas/menú Expedientes: basta con lectura/escritura en cualquiera. */
export const MODS_EXPEDIENTES_ACCESS = [MOD_EXPEDIENTE, MOD_CONTRATO_PRODUCTOS] as const;
